export default __webpack_public_path__ + "static/media/icon-course-failed.e2555a68.svg";